/**
 * Central PWA constants.
 *
 * All localStorage keys and behavioral thresholds live here so they are
 * consistent between the lib/pwa.ts helpers, the React hooks, and tests.
 *
 * Per `.claude/rules/pwa-patterns.md` this is the single source of truth:
 *   - Key names used by usePWAInstall / usePWAValueMoment
 *   - Value-moment trigger identifiers
 *   - Dismissal cooldown / threshold
 */

export const CACHE_VERSION = "v1.0.1";

export const INSTALL_MAX_DISMISSALS = 2;
export const INSTALL_COOLDOWN_DAYS = 30;

export const VALUE_MOMENTS = [
  "dashboard_viewed_3x",
  "subscribed_to_alerts",
  "repeat_visits",
] as const;
export type ValueMoment = (typeof VALUE_MOMENTS)[number];

/** Number of page-views before `repeat_visits` fires. */
export const REPEAT_VISIT_COUNT_THRESHOLD = 3;
/** Number of distinct calendar days before `repeat_visits` fires. */
export const REPEAT_VISIT_DAY_THRESHOLD = 3;
/** Number of times the dashboard must be viewed before `dashboard_viewed_3x` fires. */
export const DASHBOARD_VIEW_THRESHOLD = 3;

/** localStorage keys (namespaced `pwa-` prefix). */
export const PWA_STORAGE_KEYS = {
  installDismissed: "pwa-install-dismissed",
  dismissCount: "pwa-install-dismiss-count",
  valueMomentReached: "pwa-value-moment-reached",
  visitCount: "pwa-visit-count",
  firstVisitDate: "pwa-first-visit-date",
  dashboardViewCount: "pwa-dashboard-view-count",
} as const;

/** Expose test helpers on window in non-production environments. */
export const EXPOSE_TEST_HELPERS =
  typeof process !== "undefined" && process.env.NODE_ENV !== "production";
